import { Box, Typography, useTheme } from '@mui/material';
// import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
// import useAxios from 'packages/novous_web/src/api/useAxios';
// import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
// import MultiSelectDropdown from 'packages/novous_web/src/common/components/MultiSelect';
// import CheckboxesTags from 'packages/novous_web/src/common/components/MultiSelect';
// import React, { useEffect, useState } from 'react';
import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

const DriverCoachingGraph = ({ driverId, dateState }: any) => {
  const theme = useTheme();
  // const { user } = useAuth();
  // const [selectedWarnings, setSelectedWarnings] = useState<string[]>([]);
  // const [allWarningTypes, setAllWarningTypes] = useState<any>([]);
  // const [dropdownData, setDropDownData] = useState<any>([]);
    // const {
    //   data: filterGraphData,
    //   error: filterGraphDataError,
    //   loading: filterGraphDataLoading,
    //   fetchData: fetchAllFilterGraphData,
    // } = useAxios<any>(API_ENDPOINTS.alarm.DRIVER_ALERT_INCIDENT_CHART, "POST");
  const chartData = [
    { name: "Jan", value: 33, val: 10 },
    { name: "Feb", value: 40, val: 5 },
    { name: "Mar", value: 77, val: 20 },
    { name: "Apr", value: 56, val: 11 },
    { name: "May", value: 32, val: 40 },
    { name: "Jun", value: 76, val: 33 },
    { name: "Jul", value: 54, val: 20 },
    { name: "Aug", value: 51, val: 55 },
    { name: "Sep", value: 10, val: 80 },
    { name: "Oct", value: 88, val: 20 },
    { name: "Nov", value: 84, val: 10 },
    { name: "Dec", value: 59, val: 30 },
  ];
  // const [chartData, setChartData] = useState<any>([]);
  // const { data: alert1Data, fetchData: fetch1AlertData } = useAxios<any>(
  //   `${API_ENDPOINTS.alarm.DRIVER_ALERT_ALL_WARNING}`,
  //   "POST"
  // );

  // useEffect(() => {
  //   if (user?.customer_id) {
  //     fetch1AlertData({ fleetId: user.customer_id, startDate: '2025-03-01', endDate: '2025-03-22' });
  //   }
  // }, [user]);
  // useEffect(() => {
  //   if (alert1Data?.data) {
  //     setAllWarningTypes([...(alert1Data.data.criticalWarningType || []), ...(alert1Data.data.nonCriticalWarningType || [])]);
  //   }
  // }, [alert1Data]);
  // console.log(dropdownData, 'dropdown data');
  // useEffect(() => {
  //   if (dropdownData?.length > 0) {
  //     fetchAllFilterGraphData({ fleetId: user?.customer_id, alertNames: dropdownData, driverId: driverId, startDate: dateState.startDate, endDate: dateState.endDate });
  //   }
  // }, [dropdownData])
  // useEffect(() => {
  //    if (filterGraphData?.data) {
  //     const { dateList, data } = filterGraphData.data;
  //     const totalSums = Object.keys(data).reduce((acc, key) => {
  //       const sum = data[key].reduce((sum: number, value: number) => sum + value, 0);
  //       acc[key] = sum;
  //       return acc;
  //     }, {} as Record<string, number>);
  //     const overallTotal = Object.values(totalSums).reduce((sum, value) => sum + value, 0);
  //     console.log("Overall Total:", overallTotal); // Example: 40
  //     const filteredData = dateList.map((item: any) => ({
  //       name: item,
  //       value: totalSums
  //     }));
  //     // setChartData(filteredData);
  //    }
  // }, [filterGraphData]);
  return (
    <Box className="w-full h-full flex flex-col border rounded-md p-4 gap-2 items-start mt-2">
      <Typography variant="body1" className="mb-5">
        Driver Incident Trend
      </Typography>
      {/* <MultiSelectDropdown
        options={allWarningTypes.map((warning: string) => ({
          id: warning,
          name: warning
        }))}
        selectedValues={selectedWarnings}
        label="Filter Warnings"
        onSelectionChange={(selected: string[]) => {
          setSelectedWarnings(selected);
          const selectedWarningTypes = allWarningTypes.filter((warning: string) =>
            selected.includes(warning)
          );
          setDropDownData(selectedWarningTypes);
        }}
      /> */}
      <div className="flex sm:flex-row w-full justify-center items-center flex-col gap-4">
        <Box className="w-full flex-1 h-full flex justify-center items-center">
          <ResponsiveContainer width="100%" height={300}>
            <AreaChart data={chartData}>
              <defs>
                {/* Gradient for first area */}
                <linearGradient id="blackGradient" x1="0" y1="1" x2="0" y2="0">
                  <stop offset="0%" stopColor="rgba(0, 0, 0, 0.15)" />
                  <stop offset="100%" stopColor="rgba(0, 0, 0, 0)" />
                </linearGradient>

                {/* Gradient for second area */}
                <linearGradient id="primaryGradient" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="rgba(85, 71, 221, 0)" />
                  <stop offset="52.21%" stopColor="rgba(85, 71, 221, 0.25)" />
                </linearGradient>
              </defs>

              <XAxis dataKey="name" />
              <YAxis domain={[0, "dataMax"]} />
              <CartesianGrid strokeDasharray="3 3" />
              <Tooltip
                formatter={(value: number) => `${value}%`}
                cursor={false}
                contentStyle={{
                  background: theme.palette.background.paper,
                  color: theme.palette.text.primary,
                }}
                labelStyle={{ color: theme.palette.text.primary }}
                itemStyle={{ color: theme.palette.text.primary }}
              />

              {/* Area with black gradient */}
              <Area
                type="monotone"
                dataKey="value"
                stroke={theme.palette.primary.main}
                strokeWidth={2}
                fill="url(#blackGradient)"
                fillOpacity={1}
              />

              {/* Area with primary gradient */}
              <Area
                type="monotone"
                dataKey="val"
                stroke={theme.palette.grey[400]}
                strokeWidth={2}
                fill="url(#primaryGradient)"
                fillOpacity={1}
              />
            </AreaChart>
          </ResponsiveContainer>
        </Box>
      </div>
    </Box>
  );
};

export default DriverCoachingGraph;
